import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import { ImStatsDots } from 'react-icons/im';

let ViewButton = (props) => {
    return (
        <IconButton 
            aria-label="Download"
            onClick={() => props.onClick()}
        >
            <ImStatsDots />
        </IconButton>
    );
}

export default ViewButton;

  